import { API_BASE_URL } from '../config';

const DISTRICT_MANAGER_BASE = `${API_BASE_URL}`;

export const districtManagerService = {
    // Obtener incidencias pendientes
    getPendingUnrealizables: async () => {
        const token = localStorage.getItem("control_campo_token");
        console.log('🔗 [Service] URL:', `${DISTRICT_MANAGER_BASE}/district-manager/pending-unrealizables`);
        console.log('🔑 [Service] Token disponible:', !!token);

        try {
            const response = await fetch(`${DISTRICT_MANAGER_BASE}/district-manager/pending-unrealizables`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            console.log('📡 [Service] Response status:', response.status, response.statusText);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('❌ [Service] Error HTTP:', response.status, errorText);
                throw new Error(`Error ${response.status}: ${errorText}`);
            }

            const data = await response.json();
            console.log('📊 [Service] Response data:', data);
            console.log('✅ [Service] Success:', data.success);
            console.log('🔢 [Service] Count:', data.count);
            console.log('📋 [Service] Unrealizables length:', data.unrealizables?.length);

            if (data.unrealizables && data.unrealizables.length > 0) {
                console.log('👤 [Service] Primer tecnico:', data.unrealizables[0].technician);
                console.log('🏷️ [Service] Primer motivo:', data.unrealizables[0].reason);
            }

            return data;
        } catch (error) {
            console.error('💥 [Service] Error en fetch:', error);
            throw error;
        }
    },

    // Obtener detalles de incidencia
    getUnrealizableDetail: async (id) => {
        const token = localStorage.getItem("control_campo_token");
        console.log('🔗 [Service] Obteniendo detalle de incidencia:', id);

        const response = await fetch(`${DISTRICT_MANAGER_BASE}/district-manager/unrealizable/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Error obteniendo detalles:', response.status, errorText);
            throw new Error(`Error ${response.status}: ${errorText}`);
        }

        const data = await response.json();
        console.log('📊 [Service] Detalle obtenido:', data);
        return data;
    },

    // Aprobar incidencia
    // ============================================
    // ACTUALIZADO: Ahora con timeout de 120 segundos
    // ============================================
    approveUnrealizable: async (id, data) => {
        const token = localStorage.getItem("control_campo_token");
        console.log('✅ [Service] Aprobando incidencia:', id);
        console.log('📦 [Service] Data:', data);

        const formData = new FormData();

        formData.append('manager_lat', data.latitude || data.manager_lat);
        formData.append('manager_lng', data.longitude || data.manager_lng);
        formData.append('justification_duration', data.justification_duration.toString());

        if (data.manager_comments) {
            formData.append('manager_comments', data.manager_comments);
        }

        // Agregar fotos de evidencia
        data.evidence_photos.forEach((photo) => {
            formData.append('evidence_photos', photo);
        });

        console.log('📤 [Service] FormData preparado, enviando...');

        // ✅ CREAR CONTROLLER PARA MANEJAR TIMEOUT
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            console.warn('⏱️ [Service] Timeout de 120 segundos alcanzado, abortando...');
            controller.abort();
        }, 120000); // 120 segundos = 2 minutos

        try {
            const response = await fetch(`${DISTRICT_MANAGER_BASE}/district-manager/unrealizable/${id}/approve`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData,
                signal: controller.signal // ✅ AGREGAR SIGNAL
            });

            clearTimeout(timeoutId); // ✅ LIMPIAR TIMEOUT SI COMPLETA ANTES

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.error('❌ Error aprobando:', response.status, errorData);
                throw new Error(errorData.detail || `Error ${response.status}`);
            }

            const result = await response.json();
            console.log('✅ [Service] Aprobación exitosa:', result);
            return result;
        } catch (error) {
            // ✅ MANEJAR ERROR DE TIMEOUT
            if (error.name === 'AbortError') {
                console.error('⏱️ [Service] TIMEOUT: La carga tardó más de 120 segundos');
                throw new Error('Timeout: La carga de imágenes tardó demasiado. Por favor intenta de nuevo.');
            }
            throw error;
        }
    },

    // Rechazar incidencia
    // ============================================
    // ACTUALIZADO: Ahora con timeout de 120 segundos
    // ============================================
    rejectUnrealizable: async (id, data) => {
        const token = localStorage.getItem("control_campo_token");
        console.log('❌ [Service] Rechazando incidencia:', id);
        console.log('📦 [Service] Data:', data);

        const formData = new FormData();

        formData.append('manager_lat', data.latitude || data.manager_lat);
        formData.append('manager_lng', data.longitude || data.manager_lng);
        formData.append('manager_comments', data.manager_comments);

        // Agregar fotos de evidencia
        data.evidence_photos.forEach((photo) => {
            formData.append('evidence_photos', photo);
        });

        console.log('📤 [Service] FormData preparado, enviando...');

        // ✅ CREAR CONTROLLER PARA MANEJAR TIMEOUT
        const controller = new AbortController();
        const timeoutId = setTimeout(() => {
            console.warn('⏱️ [Service] Timeout de 120 segundos alcanzado, abortando...');
            controller.abort();
        }, 120000); // 120 segundos = 2 minutos

        try {
            const response = await fetch(`${DISTRICT_MANAGER_BASE}/district-manager/unrealizable/${id}/reject`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData,
                signal: controller.signal // ✅ AGREGAR SIGNAL
            });

            clearTimeout(timeoutId); // ✅ LIMPIAR TIMEOUT SI COMPLETA ANTES

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.error('❌ Error rechazando:', response.status, errorData);
                throw new Error(errorData.detail || `Error ${response.status}`);
            }

            const result = await response.json();
            console.log('✅ [Service] Rechazo exitoso:', result);
            return result;
        } catch (error) {
            // ✅ MANEJAR ERROR DE TIMEOUT
            if (error.name === 'AbortError') {
                console.error('⏱️ [Service] TIMEOUT: La carga tardó más de 120 segundos');
                throw new Error('Timeout: La carga de imágenes tardó demasiado. Por favor intenta de nuevo.');
            }
            throw error;
        }
    },

    // Obtener historial
    getMyApprovals: async () => {
        const token = localStorage.getItem("control_campo_token");
        console.log('📚 [Service] Obteniendo historial...');

        const response = await fetch(`${DISTRICT_MANAGER_BASE}/district-manager/my-approvals`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('❌ Error obteniendo historial:', response.status, errorText);
            throw new Error(`Error ${response.status}: ${errorText}`);
        }

        const data = await response.json();
        console.log('📊 [Service] Historial obtenido:', data);
        return data;
    }
};